document.addEventListener('DOMContentLoaded', () => {
  
  function hideUnavailableFilteredProducts() {
    const urlParams = new URLSearchParams(window.location.search);
    const activeFilters = {};

    // 1. Group filters by their category key (e.g., 'filter.v.option.size': ['Small', 'Medium'])
    urlParams.forEach((value, key) => {
      if (key.includes('filter.v.option')) {
        if (!activeFilters[key]) activeFilters[key] = [];
        activeFilters[key].push(value);
      }
    });

    // If no variant filters are applied, exit the function
    if (Object.keys(activeFilters).length === 0) return;

    // 2. Select all product cards on the page. 
    const productCards = document.querySelectorAll('.product-grid__item');

    productCards.forEach(card => {
      const scriptTag = card.querySelector('[data-product-variants]');
      if (!scriptTag) return;

      try {
        const variants = JSON.parse(scriptTag.textContent);
        
        // 3. Check if the product has ANY variant that matches the active filters AND is in stock
        const hasAvailableMatchingVariant = variants.some(variant => {
          
          // For EVERY filter category (like size, color), the variant must match AT LEAST ONE selected value
          const matchesAllFilterCategories = Object.keys(activeFilters).every(filterKey => {
            const filterGroupValues = activeFilters[filterKey];
            return filterGroupValues.some(filterValue => variant.options.includes(filterValue));
          });

          return matchesAllFilterCategories && variant.available;
        });

        // 4. If no matching variants are available, hide the whole product card
        if (!hasAvailableMatchingVariant) {
          card.style.display = 'none';
        } else {
          card.style.display = ''; // Ensure it remains visible if in stock
        }
      } catch (error) {
        console.error("Error parsing variant data for filtering:", error);
      }
    });
  }

  // Run the function immediately when the page loads
  hideUnavailableFilteredProducts();

  // Run the function whenever Shopify's AJAX loads new products into the grid
  const gridContainer = document.querySelector('.product-grid');
  
  if (gridContainer) {
    const observer = new MutationObserver(() => {
      hideUnavailableFilteredProducts();
    });
    // Watch for DOM changes inside the product grid
    observer.observe(gridContainer, { childList: true, subtree: true });
  }
});